import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { DrakeCustomPageComponent } from './drake-components/drake-custom-page/drake-custom-page.component';
import { DrakeScopeFormComponent } from './drake-components/drake-scope-form/drake-scope-form.component';
import { DrakeScopeGridComponent } from './drake-components/drake-scope-grid/drake-scope-grid.component';
import { DrakeProfileComponent } from './drake-components/drake-profile/drake-profile.component';
import { UserComponent } from './layout/common/user/user.component';
import { DrakeScopeQuickeditComponent } from './drake-components/drake-scope-quickedit/drake-scope-quickedit.component';
import { DrakeSettingsComponent } from './drake-components/drake-settings/drake-settings.component';
import { DrakeScopeFormPrintComponent } from './drake-components/drake-scope-form-print/drake-scope-form-print.component';
import { RegistrationStep2Component } from './modules/auth/registration-step2/registration-step2.component';
import { AuthSignUpComponent } from './modules/auth/sign-up/sign-up.component';
import { DrakeScopeSearchComponent } from './drake-components/drake-scope-search/drake-scope-search.component';
import { ConfirmEmailComponent } from './modules/auth/confirm-email/confirm-email.component';
import { DrakeChartsComponent } from './drake-dashboards/drake-chart/drake-chart.component';
import { LoginStep2Component } from './modules/auth/login-step2/login-step2.component';
import { DrakeScopeListviewComponent } from './drake-components/drake-scope-listview/drake-scope-listview.component';
import { ModuleManagementComponent } from './modules/payment-modules/module-management/module-management.component';
import { ModulePaymentComponent } from './modules/payment-modules/module-payment/module-payment.component';
import { HelpRedirectComponent } from './drake-components/help-component/help-component';
import { AppLinkComponent } from './modules/auth/app-link/app-link.component';
import { DrakeAiAnalysisComponent } from './drake-components/drake-ai-analysis/drake-ai-analysis.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'p/home' },

    // Redirect signed-in user to the '/example'
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'p/home' },


    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'confirm-email/:id', component: ConfirmEmailComponent },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'login-step2', component: LoginStep2Component },
            {
                path: 'sign-up',
                component: AuthSignUpComponent,
                children: [
                    {
                        path: 'a/REGISTRATION/f',
                        component: DrakeScopeFormComponent,
                        data: { isDefault: false, forcedScope: 'REGISTRATION' }

                    }
                ]
            },
            { path: 'registration-step2', component: RegistrationStep2Component },
            { path: 'app', component: AppLinkComponent },
            { path: 'app/:id', component: AppLinkComponent },



        ]
    },


    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') },
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') }
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'module-management', component: ModuleManagementComponent }, //component di acquisto dei moduli
            { path: 'module-payment', component: ModulePaymentComponent }, //component di acquisto dei moduli sezione pagamento
            { path: 'd', loadChildren: () => import('app/drake-components/drake-scope-grid/drake-scope-grid.routes') },
            { path: 'd/:scope', component: DrakeScopeGridComponent }, //Visualizzazione elenco record con griglia
            //{ path: 'd/:scope/c/:component', component: GrigliaTelerikComponent }, //Visualizzazione elenco record con componente custom
            { path: 'd/:scope/f', component: DrakeScopeFormComponent, data: { isDefault: true } }, //Inserimento singolo record con scheda standard
            { path: 'd/:scope/f/:id', component: DrakeScopeFormComponent, data: { isDefault: true } }, //Visualizzazione singolo record con scheda standard
            { path: 'd/:scope/f/:id/t/:tpl', component: DrakeScopeFormComponent, data: { isDefault: true } }, //Visualizzazione singolo record con scheda custom
            { path: 'd/:scope/f/:id/p', component: DrakeScopeFormPrintComponent }, //Stampa singolo record con scheda standard
            { path: 'd/:scope/f/:id/t/:tpl/p', component: DrakeScopeFormComponent, data: { isDefault: true } }, //Stampa singolo record con scheda custom
            //{ path: 'd/:scope/f/:id/c/:component', component: GrigliaTelerikComponent }, //Visualizzazione singolo record con componente custom
            { path: 'd/:scope/v', component: DrakeScopeGridComponent }, // Visualizzazione con default viewCode

            { path: 'd/:scope/v/:viewCode', component: DrakeScopeGridComponent },
            { path: 'd/:scope/v/:viewCode/c/:componentCode', component: DrakeScopeListviewComponent },

            { path: 'd/:scope/q', component: DrakeScopeQuickeditComponent }, //Visualizzazione elenco record con griglia
            { path: 'd/:scope/v/:viewCode/q', component: DrakeScopeQuickeditComponent },

            //{ path: 'd/:scope/v/:view/c/:component', component: GrigliaTelerikComponent },
            { path: 'p/:pageCode', component: DrakeCustomPageComponent },
            { path: 'p/:pageCode/:id', component: DrakeCustomPageComponent },

            { path: 'profile', component: DrakeProfileComponent },
            { path: 'd/USERS/f/:id/t/:tpl', component: DrakeScopeFormComponent, data: { isDefault: true } },

            { path: 'settings', component: DrakeSettingsComponent },
            { path: 'd/SETTINGS/f/:id', component: DrakeScopeFormComponent, data: { isDefault: true } },

            { path: 'd/:viewCode/filter', component: DrakeScopeSearchComponent },

            { path: 'p/stats', component: DrakeChartsComponent },

            { path: 'help-support', component: HelpRedirectComponent },
            { path: 'ai-analysis', component: DrakeAiAnalysisComponent },

            { path: '**', redirectTo: 'p/home' },

            { path: 'scope', loadChildren: () => import('app/components/scope/scope.routes') },
            { path: 'field', loadChildren: () => import('app/components/field/field.routes') },
            { path: 'command', loadChildren: () => import('app/components/command/command.routes') },

        ]
    },
];
